module.exports = __webpack_public_path__ + "img/P150T_weapon_59.73a12cfb.png";